import { useLiteTradeAsset } from '../../../../modules/LiteTrade/liteTradeHooks';
import {
    MobileWidgetGradientCardNameIconButtonStyled,
    MobileWidgetGradientCardNameIconContainerStyled,
    MobileWidgetGradientCardNameIconDefaultStyled,
    MobileWidgetGradientCardNameIconStyled,
    MobileWidgetGradientCardNameIconWrapperStyled,
} from './styled/MobileWidgetGradientCardsNameIconStyled';
import BinIcon from '../../../../components/icon/Icon';
import { useCallback } from 'react';
import { WIDGETS } from '../mobileWidgetsConstants';
import type { ILiteTradeAssetSymbol } from '../../../../modules/LiteTrade/types/liteTradeReducer.t';
import { useSelector } from 'react-redux';
import { getLiteTradeAssetsBySymbol } from '../../../../modules/LiteTrade/liteTradeSelectors';
import IconAsset from '../../../../components/icon/IconAsset';

interface IMobileWidgetGradientCardNameIconProps {
    collectionKey: string,
    disabled?: boolean,
    symbol: ILiteTradeAssetSymbol,
}

function MobileWidgetGradientCardNameIcon(props: IMobileWidgetGradientCardNameIconProps) {
    const userAssetsMap = useSelector(getLiteTradeAssetsBySymbol);
    const { collectionKey, symbol, disabled } = props;
    const {
        isAssetConfigDefault,
        gradientCardsNameIconBgStart,
        gradientCardsNameIconBgEnd,
        gradientCardsNameIconColor,
        gradientCardsNameIconName,
        openAssetSlide,
    } = useLiteTradeAsset(symbol);
    const asset = userAssetsMap[symbol];

    const handleClick = useCallback(() => {
        openAssetSlide(collectionKey, WIDGETS.GRADIENT_CARDS_NAME_ICON);
    }, [collectionKey, openAssetSlide]);

    return <MobileWidgetGradientCardNameIconStyled
        gradientStart={gradientCardsNameIconBgStart}
        gradientEnd={gradientCardsNameIconBgEnd}
        color={gradientCardsNameIconColor}
        onClick={handleClick}
        disabled={disabled}
    >
        <MobileWidgetGradientCardNameIconContainerStyled>
            <h4>{asset?.info.description}</h4>
            <MobileWidgetGradientCardNameIconButtonStyled>
                <BinIcon name={'IcForward'}/>
            </MobileWidgetGradientCardNameIconButtonStyled>
        </MobileWidgetGradientCardNameIconContainerStyled>
        {
            isAssetConfigDefault && <MobileWidgetGradientCardNameIconDefaultStyled>
                {symbol.charAt(0)}
            </MobileWidgetGradientCardNameIconDefaultStyled>
        }
        {
            !isAssetConfigDefault && <MobileWidgetGradientCardNameIconWrapperStyled>
                <IconAsset symbol={gradientCardsNameIconName || symbol} size={120}/>
            </MobileWidgetGradientCardNameIconWrapperStyled>
        }
    </MobileWidgetGradientCardNameIconStyled>;
}

export default MobileWidgetGradientCardNameIcon;
